// @flow

import React, { type ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  Highlights,
  Image,
  ImageContainer,
  Pill,
  Price,
  SoldOutOverlay,
  Stock,
  Title,
  Tile,
} from './atoms';
import { Flex } from '../../../../../grid';
import { getSoldOutLabel, getUspFeaturesLabel, getPerMonthAbbrv } from '../../../../../../store/configuratorSettings/selectors';
import { getActivePackageId } from '../../../../../../store/configuration/actives';
import type { PackageContainee } from '../../../../../../types/pdb';

type Contains = Array<PackageContainee>;

type OwnProps = {|
  packageId: number,
  title: string,
  stock?: string,
  price: string,
  image?: ?{
    url: string,
    alt: string,
  },
  contains: Contains,
  blocksPerRow?: number,
  blockCount?: number,
  onClick: Function,
  soldOut?: boolean,
|};

type StateProps = {|
  features: string,
  soldOutLabel: string,
  activeCarPackage: ?number,
  postfix: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const ConfigPackage: ComponentType<Props> = ({
  packageId,
  activeCarPackage,
  title,
  stock,
  price,
  image,
  contains,
  features,
  blocksPerRow = 1,
  blockCount = 1,
  onClick,
  soldOut,
  soldOutLabel,
  postfix,
}) => (
  <Tile
    active={!soldOut && packageId === activeCarPackage}
    blocksPerRow={blocksPerRow}
    blockCount={blockCount}
    onClick={() => { if (!soldOut) onClick(); }}
    soldOut={soldOut || false}
  >
    {soldOut && (
      <SoldOutOverlay>
        <Pill>{soldOutLabel}</Pill>
      </SoldOutOverlay>
    )}
    <ImageContainer>
      {image && image.url && (
        <Image src={image.url} alt={image.alt} />
      )}
    </ImageContainer>
    <Stock amount={stock} />
    <Flex justifyContent="space-around" alignItems="center" flexDirection="column">
      <Title>
        {title}
      </Title>
      <Price
        amount={Number(price)}
        active={packageId === activeCarPackage}
        postfix={postfix}
      />
    </Flex>
    <Highlights
      title={features}
      active={packageId === activeCarPackage}
      items={contains.filter(item => item.highlight) || []}
    />
  </Tile>
);

const mapStateToProps = (state): StateProps => ({
  features: getUspFeaturesLabel(state),
  soldOutLabel: getSoldOutLabel(state),
  activeCarPackage: getActivePackageId(state),
  postfix: getPerMonthAbbrv(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ConfigPackage);
